import type { OffersEmbedResolvedData } from "../schemas/upsell-constructs";

// Structural shape of the `OneTickField` styles prop in `@codway-dev/ui`.
// Defined here (instead of importing) so `@codway-dev/shared` stays free
// of UI-package dependencies — both admin and widget spread the result
// into `<OneTickField styles={...} />` and TypeScript matches structurally.
export interface OneTickEmbedStyles {
  backgroundColor?: string;
  borderStyle?: "solid" | "dashed" | "dotted" | "none";
  borderWidth?: number;
  borderColor?: string;
  borderRadius?: number;
}

export interface OneTickEmbedFieldProps {
  textTemplate: string;
  productTitle: string;
  priceLabel: string;
  description?: string;
  imageUrl?: string;
  textColor?: string;
  descriptionColor?: string;
  styles?: OneTickEmbedStyles;
}

export function mapOneTickResolvedDataToFieldProps(
  resolvedData: OffersEmbedResolvedData,
  formatPrice: (amount: number) => string
): OneTickEmbedFieldProps | null {
  const dd = resolvedData.display_data;
  if (dd.component_type !== "one_tick") return null;

  const target = resolvedData.product_target;
  if (!target) return null;

  const productTitle =
    dd.product_title_override ?? target.display_meta?.title ?? "";
  const imageUrl = dd.image_url ?? target.display_meta?.image_url;

  const pricing = resolvedData.pricing_logic;
  const priceLabel =
    pricing.action === "fixed_price_per_item"
      ? formatPrice(pricing.amount)
      : "";

  const ddStyles = dd.styles;
  const styles: OneTickEmbedStyles | undefined = ddStyles
    ? {
        backgroundColor: ddStyles.background_color,
        borderStyle: ddStyles.border_style,
        borderWidth: ddStyles.border_width,
        borderColor: ddStyles.border_color,
        borderRadius: ddStyles.border_radius,
      }
    : undefined;

  return {
    textTemplate: dd.checkbox_text_template,
    productTitle,
    priceLabel,
    description: dd.description,
    imageUrl,
    textColor: dd.text_color,
    descriptionColor: dd.description_color,
    styles,
  };
}
